import { DsrFragments } from '@getaccept/lib-shared/src/library/graphql/dsr.fragments';
import gql from 'graphql-tag';
import { DealroomQueryKey } from '@getaccept/lib-shared/src/rooms/enums/dealroom-query-key';

export const loadDealroomDirectories = gql`
  query loadDealroomDirectories(
    $searchTerms: [String!]
    $directory: String
    $limit: Int!
    $offset: Int!
    $sortBy: DsrDirectorySortAttribute
    $sortOrder: SortOrder
  ) {
    ${DealroomQueryKey.Directories}(
      searchTerms: $searchTerms
      directory: $directory
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      directories {
        ...dsrDirectoryFragment
      }
      totalCount
    }
  }
  ${DsrFragments.directory}
`;
